import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { t } from "i18next";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import {
  addTypeConge,
  getsouche_Type_conge,
  updateTypeConge
} from '../../Services/Pointeuse/CongeApi';

export default function CongeTypeForm({ objdata, getData }) {
  const [modif, setmodif] = useState(false);
  const [data, setdata] = useState({
    code_conge: '',
    code_generated: localStorage.getItem('code_generated'),
    libelle: '',
    affect_solde: false,
    conge_plafonne: false,
    conge_anticipe: false,
    conge_cumulable: false,
    nb_jours_plafonne: '',
    nb_jours_cumulable: '',
  });

  useEffect(() => {
    if (objdata && objdata?.id) {
      setmodif(true);
      setdata({
        id: objdata.id,
        code_conge: objdata.code_conge,
        code_generated: localStorage.getItem('code_generated'),
        libelle: objdata.libelle,
        affect_solde: objdata.affect_solde === 1,
        conge_plafonne: objdata.conge_plafonne === 1,
        conge_anticipe: objdata.conge_anticipe === 1,
        conge_cumulable: objdata.conge_cumulable === 1,
        nb_jours_plafonne: objdata.nb_jours_plafonne || '',
        nb_jours_cumulable: objdata.nb_jours_cumulable || '',
      });
    } else {
      souche();
    }
  }, [objdata]);

  const souche = () => {
    getsouche_Type_conge().then((res) => {
      if (res?.data) {
        const last = res.data.last_code;
        const seq = res.data.seq;
        const number = last ? parseInt(last.split(seq).pop()) + 1 : 1;

        setdata(prev => ({
          ...prev,
          code_conge: `${seq}${number}`
        }));
      }
    });
  };

  const handelchange = (name, value) => {
    setdata(prev => ({ ...prev, [name]: value }));
  };

  const handelsave = () => {
    const newdata = {
      ...data,
      affect_solde: data.affect_solde ? 1 : 0,
      conge_plafonne: data.conge_plafonne ? 1 : 0,
      conge_anticipe: data.conge_anticipe ? 1 : 0,
      conge_cumulable: data.conge_cumulable ? 1 : 0,
    };

    const saveFn = data.id ? updateTypeConge : addTypeConge;

    saveFn(newdata).then((res) => {
      if (res.status === 200 || res.status === 201) {
        toast.success(t(data.id ? "type contract est modifié" : "type contract est enregistrée"));

        setdata({
          code_conge: '',
          code_generated: localStorage.getItem('code_generated'),
          libelle: '',
          affect_solde: false,
          conge_plafonne: false,
          conge_anticipe: false,
          conge_cumulable: false,
          nb_jours_plafonne: '',
          nb_jours_cumulable: '',
        });

        souche();
        getData();
      }
    });
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="tab-content adminsetting-content">
          <div className="tab-pane fade show active">
            <div className="card">
              <div className="card-body">

                <div className='row mt-3'>
                  <label>{t('code_conge')}</label>
                  <input type='text' className="form-control" value={data.code_conge} readOnly />
                </div>

                <div className='row mt-3'>
                  <label>{t('Libelle')}</label>
                  <input
                    type='text'
                    readOnly={modif}
                    className="form-control"
                    value={data.libelle}
                    onChange={(e) => handelchange('libelle', e.target.value)}
                  />
                </div>

                <div className='form-check mt-3'>
                  <input
                    type='checkbox'
                    className="form-check-input"
                    id="affect_solde"
                    disabled={modif}
                    checked={data.affect_solde}
                    onChange={() => handelchange('affect_solde', !data.affect_solde)}
                  />
                  <label className="form-check-label" htmlFor="affect_solde">{t('affect_solde')}</label>
                </div>

                <div className='form-check mt-3'>
                  <input
                    type='checkbox'
                    className="form-check-input"
                    id="conge_plafonne"
                    disabled={modif}
                    checked={data.conge_plafonne}
                    onChange={() => handelchange('conge_plafonne', !data.conge_plafonne)}
                  />
                  <label className="form-check-label" htmlFor="conge_plafonne">{t('Congé Plafonné')}</label>
                </div>

                {data.conge_plafonne && (
                  <div className='row mt-3'>
                    <label>{t('Nombre de jours plafonnés')}</label>
                    <input
                      type='number'
                      className="form-control col-4"
                      value={data.nb_jours_plafonne}
                      onChange={(e) => handelchange('nb_jours_plafonne', e.target.value)}
                      disabled={modif}
                    />
                  </div>
                )}

                <div className='form-check mt-3'>
                  <input
                    type='checkbox'
                    className="form-check-input"
                    id="conge_cumulable"
                    disabled={modif}
                    checked={data.conge_cumulable}
                    onChange={() => handelchange('conge_cumulable', !data.conge_cumulable)}
                  />
                  <label className="form-check-label" htmlFor="conge_cumulable">{t('Congé Cumulable')}</label>
                </div>

                {data.conge_cumulable && (
                  <div className='row mt-3'>
                    <label>{t('Nombre de jours cumulables')}</label>
                    <input
                      type='number'
                      className="form-control col-4"
                      value={data.nb_jours_cumulable}
                      onChange={(e) => handelchange('nb_jours_cumulable', e.target.value)}
                      disabled={modif}
                    />
                  </div>
                )}

                <div className='form-check mt-3'>
                  <input
                    type='checkbox'
                    className="form-check-input"
                    id="conge_anticipe"
                    disabled={modif}
                    checked={data.conge_anticipe}
                    onChange={() => handelchange('conge_anticipe', !data.conge_anticipe)}
                  />
                  <label className="form-check-label" htmlFor="conge_anticipe">{t('Congé Anticipé')}</label>
                </div>

              </div>
              <div className="card-footer float-md-right">
                {modif ? (
                  <Link to="#" onClick={() => setmodif(false)} className="btn btn-primary float-md-right">
                    {t("Modifier")}
                  </Link>
                ) : (
                  <Link to="#" onClick={handelsave} className="btn btn-primary float-md-right">
                    {t("Enregistrer")}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

